module.exports = __webpack_public_path__ + "assets/img/937e657da4f93f1b37cec36f5c604a18.png";